import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "./sketchPad.css";
import { ToastContainer, toast } from "react-toastify";

const SketchPad = (props) => {
  const [displayBasic, setDisplayBasic] = useState(false);
  const sigCanvas = useRef(null);
  const [showSignature, setShowSignature] = useState(false);
  const [message, setMessage] = useState("");
  const [retrievedSignature, setRetrievedSignature] = useState();
  const clearCanvas = () => {
    sigCanvas.current.clear();
  };

  useEffect(() => {
    if (props.value != "") {
      setShowSignature(true);
      let data = {
        target: { name: props.name, value: props.value },
      };
      let message = "";
      let sketch;
      if (typeof props.value === "string") {
        if (props.value.includes("c2tldGNoUGFk")) {
          props.onChange(data);

          try {
            sketch = JSON.parse(props.value);
            let decryptedData = { decryptedData: sketch.data };
            setRetrievedSignature(decryptedData);

            message = sketch && sketch.message ? sketch.message : "";
          } catch (e) {
            message = props.value;
          }
        } else {
          let data = JSON.parse(props.value);
          setRetrievedSignature(data);
          message = data.message;

          let sketch = {
            data: data.decryptedData,
            type: "c2tldGNoUGFk",
            message: message,
          };
          let content = {
            target: { name: props.name, value: JSON.stringify(sketch) },
          };
          setMessage(sketch.message);
          props.onChange(content);
        }
      } else {
        message = "";
      }
      setMessage(message);
    } else {
      setShowSignature(false);
      setMessage("");
      setRetrievedSignature(undefined);
      let data = {
        target: { name: props.name, value: props.value },
      };
      props.onChange(data);
    }
  }, [props.value]);

  const saveSignature = async () => {
    const isEmpty = sigCanvas.current.isEmpty();
    if (isEmpty) {
      toast.info("SketchPad is empty", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      let content = {
        target: { name: props.name, value: null },
      };
      props.onChange(content);
      setMessage("");
      setRetrievedSignature(undefined);
      setDisplayBasic(false);
      return;
    }
    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    let sign = {
      decryptedData: dataURL,
    };
    setRetrievedSignature(sign);
    let sketch = {
      data: dataURL,
      type: "c2tldGNoUGFk",
      message: "Signed on " + new Date().toGMTString(),
    };
    let data = {
      target: { name: props.name, value: JSON.stringify(sketch) },
    };
    setMessage(sketch.message);
    props.onChange(data);
    clearCanvas();
    setDisplayBasic(false);
    setShowSignature(true);
  };

  return (
    <div>
      <Button
        icon={
          retrievedSignature && retrievedSignature.decryptedData
            ? "pi pi-eye"
            : "pi pi-pencil"
        }
        style={{ height: "30px", marginTop: "10px" }}
        onClick={(e) => {
          e.preventDefault();
          setDisplayBasic(true);
          if (retrievedSignature && retrievedSignature.decryptedData) {
            setTimeout(() => {
              sigCanvas.current.fromDataURL(retrievedSignature.decryptedData);
            }, 500);
          }
        }}
      />
      {showSignature ? (
        <span style={{ position: "relative", bottom: "5px", fontSize: "12px" }}>
          &nbsp; <i>{message != "" ? message : ""}</i>
        </span>
      ) : null}
      <Dialog
        header={props.label}
        visible={displayBasic}
        style={{ width: "95%", maxWidth: "480px", height: "auto" }}
        onHide={() => setDisplayBasic(false)}
      >
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            className: "sigCanvas",
          }}
        />
        <ToastContainer />
        <div style={{ float: "right", marginTop: "10px" }}>
          <Button onClick={clearCanvas} label="Clear" />
          &nbsp;
          <Button onClick={saveSignature} label="Submit" />
        </div>
      </Dialog>
    </div>
  );
};

export default SketchPad;
